import axios from 'axios'
import i18n from '../../plugins/i18n'

export default {
  state: {
    currentUser: null
  },
  mutations: {
    setCurrentUser (state, item) {
      state.currentUser = item
    }
  },
  actions: {
    fetchCurrentUser ({ commit }) {
      return axios
        .get(`${i18n.locale}/api/public/user/current`)
        .then(({ data }) => {
          commit('setCurrentUser', data)
          return Promise.resolve(data)
        })
    }
  }
}
